import {QuickAddModal} from '@/scripts/optional/quick-add';
import {safeDefineElement} from '@/scripts/core/global';
import { ProductForm } from '@/scripts/product/product-form';
safeDefineElement(QuickAddModal);
safeDefineElement(ProductForm)
